<template>
  <i :class="[ns.b()]" :style="style">
    <Component
      :is="slots?.default || 'iconpark-icon'"
      v-bind="bind"
      width="1em"
      height="1em"
    />
  </i>
</template>

<script lang="ts" setup>
import { computed, onMounted, useSlots } from 'vue'
import { useNamespace } from '@xzx-design/hooks'
import { iconProps } from './icon'

defineOptions({
  name: 'XzxIcon',
})

const props = defineProps(iconProps)

const slots = useSlots()

const ns = useNamespace('icon')

const bind = computed(() => ({
  ...props,
  size: typeof props.size === 'number' ? `${props.size}px` : props.size,
}))

const style = computed(() =>
  slots?.default
    ? {
        fontSize:
          typeof props.size === 'number' ? `${props.size}px` : props.size,
        '--color': props.color,
      }
    : undefined
)

declare const __XZX_ICON_URL__: string

const initIconPark = () => {
  if (document.querySelector('#xzx-icon-park-script')) return
  const script = document.createElement('script')
  try {
    script.src =
      (__XZX_ICON_URL__ as string) ||
      'https://ecampus-test.xzxpay.com.cn/xzx-design/xzx-icons.js'
  } catch {
    script.src = 'https://ecampus-test.xzxpay.com.cn/xzx-design/xzx-icons.js'
  }

  script.id = 'xzx-icon-park-script'
  document.head.appendChild(script)
}

onMounted(() => {
  initIconPark()
})
</script>
